export default {
  inserted(el, binding) {
    let isDragging = false;
    let offsetX, offsetY, startX, startY;

    // 拖拽开始事件
    const onMouseDown = (event) => {
      isDragging = true;
      offsetX = event.clientX - el.getBoundingClientRect().left;
      offsetY = event.clientY - el.getBoundingClientRect().top;
      startX = event.clientX;
      startY = event.clientY;

      // 调用用户自定义的拖拽开始函数
      if (binding.value && typeof binding.value.onStart === 'function') {
        binding.value.onStart(event, el);
      }

      // 设置鼠标移动和鼠标释放事件监听器
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      // 阻止默认行为，比如选中文本
      event.preventDefault();
      
    };

    // 拖拽中事件
    const onMouseMove = (event) => {
      if (!isDragging) return;

      // 计算新的位置
      let left = event.clientX - offsetX;
      let top = event.clientY - offsetY;

      // 应用新位置（这里只是简单设置样式，实际项目中可能需要更复杂的逻辑）
      el.style.left = `${left}px`;
      el.style.top = `${top}px`;

      // 调用用户自定义的拖拽中函数
      if (binding.value && typeof binding.value.onMove === 'function') {
        binding.value.onMove(event, el, { left, top });
      }

      // 避免和click冲突
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        el.style.pointerEvents = 'none';
      }
    };

    // 拖拽结束事件
    const onMouseUp = () => {
      isDragging = false;

      // 移除鼠标移动和鼠标释放事件监听器
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);

      // 调用用户自定义的拖拽结束函数
      if (binding.value && typeof binding.value.onEnd === 'function') {
        binding.value.onEnd(event, el);
      }
       el.style.pointerEvents = 'auto';
    };

    // 绑定事件监听器
    el.addEventListener('mousedown', onMouseDown);

    // 为了能够在unbind钩子中移除事件监听器，我们将它们保存在el的属性中
    el._mousedownHandler = onMouseDown;
    el._mousemoveHandler = onMouseMove;
    el._mouseupHandler = onMouseUp;
  }
};